import { render, staticRenderFns } from "./req_ord.vue?vue&type=template&id=6f2adb11&scoped=true&"
import script from "./req_ord.vue?vue&type=script&lang=js&"
export * from "./req_ord.vue?vue&type=script&lang=js&"
import style0 from "./req_ord.vue?vue&type=style&index=0&id=6f2adb11&scoped=true&lang=less&"
import style1 from "./req_ord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2adb11",
  null
  
)

export default component.exports